import { ArrowUpRight, BookOpenCheck } from 'lucide-react';
import { useRadarLocale } from '@/i18n/RadarLocaleContext';

export function RadarQuickStartLink() {
  const {locale, t} = useRadarLocale();
  const href = locale === 'en' ? '/buyer-radar/guide/' : '/buyer-radar/guide/zh/';
  return <a className="radar-quickstart-link" href={href} target="_blank" rel="noopener noreferrer"
    title={t('Opens in a new tab')}>
    <BookOpenCheck size={17} aria-hidden="true"/>
    <span>{t('Quick start guide')}</span>
    <ArrowUpRight size={14} aria-hidden="true"/>
  </a>;
}
